<template>
  <div class="step-campos">
    <div class="step-campos__hint">
      Configure quais campos do produto se tornam <strong>filtros</strong> no
      modal de grade. O usuário refina a lista de SKUs pelos chips no topo.
      Máximo de 5 filtros.
    </div>

    <div v-if="!campos.length" class="step-campos__empty">
      <CIcon name="cil-ban" size="lg" class="empty-icon" />
      <p>Nenhum filtro cadastrado</p>
      <small>Adicione pelo menos 1 filtro para refinar a grade.</small>
    </div>

    <div v-else class="step-campos__table-wrapper">
      <table class="step-campos__table">
        <thead>
          <tr>
            <th class="col-coluna">Atributo</th>
            <th class="col-apelido">Apelido (opcional)</th>
            <th class="col-ordem">Ordem</th>
            <th class="col-acoes"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(campo, indice) in campos" :key="`c-${indice}`">
            <td class="col-coluna">
              <select class="form-control" v-model="campo.colunaProduto">
                <option :value="null" disabled>Selecione...</option>
                <option
                  v-for="opcao in colunasFiltradas(campo.colunaProduto)"
                  :key="opcao.coluna"
                  :value="opcao.coluna"
                >
                  {{ opcao.label }}
                </option>
              </select>
            </td>
            <td class="col-apelido">
              <input
                type="text"
                class="form-control"
                v-model="campo.labelCustomizado"
                :placeholder="placeholderApelido(campo)"
                maxlength="60"
              />
            </td>
            <td class="col-ordem">
              <input
                type="number"
                class="form-control"
                v-model.number="campo.ordem"
                min="0"
                placeholder="0"
              />
            </td>
            <td class="col-acoes">
              <CButton size="sm" color="danger" @click="remover(indice)" title="Remover">
                <fa-icon icon="trash-alt" />
              </CButton>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <CButton
      color="primary"
      variant="outline"
      size="sm"
      @click="adicionar"
      :disabled="campos.length >= 5"
      class="mt-2"
    >
      <CIcon name="cil-plus" size="sm" class="mr-1" />
      Adicionar filtro
    </CButton>
    <small v-if="campos.length >= 5" class="step-campos__limite">
      Limite de 5 filtros atingido.
    </small>
  </div>
</template>

<script>
export default {
  name: "StepCampos",
  props: {
    form: { type: Object, required: true },
    colunasDisponiveis: { type: Array, default: () => [] },
  },
  computed: {
    campos() {
      if (!this.form.campos) {
        this.$set(this.form, "campos", []);
      }
      return this.form.campos;
    },
  },
  methods: {
    adicionar() {
      if (this.campos.length >= 5) return;
      this.campos.push({
        colunaProduto: null,
        labelCustomizado: "",
        ordem: this.campos.length,
        eixo: null,
      });
    },
    placeholderApelido(campo) {
      if (!campo.colunaProduto) return "ex: Cor, Tamanho";
      const opcaoColuna = (this.colunasDisponiveis || []).find(
        (opcao) => opcao.coluna === campo.colunaProduto
      );
      return opcaoColuna ? opcaoColuna.label : "ex: Cor, Tamanho";
    },
    remover(indice) {
      this.campos.splice(indice, 1);
    },
    colunasFiltradas(colunaAtual) {
      const colunasUsadas = this.campos
        .map((campo) => campo.colunaProduto)
        .filter((coluna) => coluna && coluna !== colunaAtual);
      return this.colunasDisponiveis.filter(
        (opcao) => !colunasUsadas.includes(opcao.coluna)
      );
    },
  },
};
</script>

<style scoped>
.step-campos {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.step-campos__hint {
  font-size: 13px;
  color: #475467;
  padding: 10px 12px;
  background: #f9fafb;
  border-left: 3px solid #2298a3;
  border-radius: 4px;
}

.step-campos__empty {
  text-align: center;
  padding: 32px 20px;
  color: #98a2b3;
  background: #f9fafb;
  border: 1px dashed #dddce9;
  border-radius: 10px;
}

.step-campos__empty .empty-icon {
  color: #d0d5dd;
  margin-bottom: 8px;
}

.step-campos__empty p {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 4px;
}

.step-campos__empty small {
  font-size: 12px;
}

.step-campos__table-wrapper {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  overflow: clip;
  background: #fff;
}

.step-campos__table {
  width: 100%;
  border-collapse: collapse;
}

.step-campos__table thead tr {
  background: #f9fafb;
  border-bottom: 1px solid #e4e7eb;
}

.step-campos__table th {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 10px 12px;
  text-align: left;
}

.step-campos__table td {
  padding: 8px 12px;
  border-bottom: 1px solid #f2f4f7;
  vertical-align: middle;
}

.step-campos__table tr:last-child td {
  border-bottom: none;
}

.col-coluna { width: 38%; }
.col-apelido { width: 36%; }
.col-ordem { width: 14%; }
.col-acoes { width: 12%; text-align: center; }

.step-campos__table .form-control {
  font-size: 13px;
  border-radius: 6px;
  border: 1px solid #dddce9;
  padding: 7px 10px;
}

.step-campos__table .form-control:focus {
  border-color: #3a3e81;
  box-shadow: 0 0 0 2px rgba(58, 62, 129, 0.1);
}

.step-campos__limite {
  font-size: 12px;
  color: #98a2b3;
  margin-left: 8px;
}
</style>
